import React, { useContext } from 'react';
import { Input, Select, Space, Row, Col, Card } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import "./FilterBar.css"
import { GlobalContext } from '../../context/GlobalContext';
import { Category } from '../../models/Category';
import { Franchise } from '../../models/Franchise';

const { Option } = Select;

interface Props{
   filterCategory:string
   setFilterCategory: React.Dispatch<React.SetStateAction<string>>
   filterFranchises:string
   setFilterFranchises: React.Dispatch<React.SetStateAction<string>>
   filterStatus:string
   setFilterStatus:React.Dispatch<React.SetStateAction<string>>
   filterName:string
   setFilterName: React.Dispatch<React.SetStateAction<string>>

   loadingProducts:boolean

}

const FilterBar = ({ filterFranchises, setFilterFranchises, filterStatus, setFilterStatus,loadingProducts, filterCategory, setFilterCategory, filterName, setFilterName}: Props) => {
      const { categories, franchises, loading } = useContext(GlobalContext);

    const onChangeName= (e:string) => {
      console.log(e)
      setFilterName(e);
    };

    const onChangeCategory= (e:string) => {
      console.log(e)
      setFilterCategory(e);

  };

    const onChangeFranchise = (e:string) => {
      setFilterFranchises(e);

    };

  const onChangeStatus = (e:string) => {

      setFilterStatus(e);

  };
  return (
    <Card variant="borderless" className="filter-bar-card" style={{ marginBottom: 16 }}>
      <Row gutter={[16, 16]} align="middle">
        {/* Input de Búsqueda por Nombre o SKU */}
        <Col xs={24} md={8}>
          <Input
            placeholder="Search by product name or SKU..."
            value={filterName}
            prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
            onChange={(e) => onChangeName(e.target.value)}
            style={{ borderRadius: '8px', height: '40px' }}
          />
        </Col>

        <Col xs={24} md={16}>
          <Space wrap size="middle" style={{ width: '100%', justifyContent: 'flex-end' }}>
            
            {/* Select de Categoría */}
            <Select
              placeholder="Category"
              style={{ width: 140 }}
              onChange={(value:string) => onChangeCategory(value)}
              allowClear
            >
              {
                categories.map((category:Category)=>{

                  return <Option key={`Categoria ${category.id}`} value={category.id}  >
                    {category.name}
                    </Option>
                })
              }
     
            </Select>

            {/* Select de Franquicia */}
            <Select
              placeholder="Franchise"
              style={{ width: 140 }}
              onChange={(value:string) => onChangeFranchise(value)}
              allowClear
            >
            {franchises.map((franchise:Franchise)=>{
                return <Option key={`Franquicia ${franchise.id}`} value={franchise.id}  >
                    {franchise.name}
                    </Option>
              })}
            </Select>

            {/* Select de Estatus */}
            <Select
              placeholder="Status"
              style={{ width: 140 }}
              onChange={(value:string) => onChangeStatus(value)}
              allowClear
            >
              <Option value="available">Disponible</Option>
              <Option value="soon">Proximamente</Option>
              <Option value="sold out">Agotado</Option>
            </Select>

          </Space>
        </Col>
      </Row>
    </Card>
  );
};

export default FilterBar;